const ranking = [
  { rank: 1, title: '长安秘闻录', tag: '古装悬疑', hot: '9.7万热度', change: 'up' },
  { rank: 2, title: '星际迷途', tag: '科幻冒险', hot: '8.2万热度', change: 'up' },
  { rank: 3, title: '暗夜追踪', tag: '犯罪悬疑', hot: '7.5万热度', change: 'new' },
  { rank: 4, title: '盛夏光年', tag: '青春爱情', hot: '6.8万热度', change: 'down' },
  { rank: 5, title: '云端幻想曲', tag: '动画奇幻', hot: '6.1万热度', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          本周最受牛牛用户欢迎的影视作品
        </p>
        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {ranking.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-3 md:gap-4 p-4 md:p-5 cursor-pointer transition-colors duration-150 hover:bg-primary-50/20 ${
                idx < ranking.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold shrink-0 whitespace-nowrap ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-heading text-foreground-900 truncate">{item.title}</span>
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-600 whitespace-nowrap">NEW</span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.tag}</span>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs md:text-sm text-foreground-600 font-medium whitespace-nowrap">{item.hot}</span>
                <span className={`w-5 h-5 flex items-center justify-center ${
                  item.change === 'up' ? 'text-accent-500' :
                  item.change === 'down' ? 'text-secondary-500' :
                  'text-primary-500'
                }`}>
                  <i className={`text-sm ${
                    item.change === 'up' ? 'ri-arrow-up-line' :
                    item.change === 'down' ? 'ri-arrow-down-line' :
                    'ri-sparkling-line'
                  }`}></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}